export default "__VITE_ASSET__DQ88WEEO__"